import React from 'react';
import Fullstory from './Fullstory';

const TagWrapper = () => <Fullstory />;

export default TagWrapper;
